import * as React from 'react';
import {AppContext} from "../../context/AppContext";
import {useContext} from "react";

export function Footer() {
  const { I18N } = useContext(AppContext);

  return (
    <footer data-backend>
      <dia-footer-bottom-bar>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://dia.help/impressum"
            >
              {I18N.t("Impressum")}
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://dia.help/datenschutz"
            >
              {I18N.t("Datenschutz")}
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://dia.help/interlink-teilnahmebedingungen"
            >
              {I18N.t("Teilnahmebedingungen")}
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://dia.help/interlink-leistungsbeschreibung"
            >
              {I18N.t("Leistungsbeschreibung")}
            </a>
          </li>
        </ul>
      </dia-footer-bottom-bar>
    </footer>
  )
}
